import { kuiperClassNames } from '../../../utils'

export const remainingLength = (maxLength, currentLength) =>
  maxLength - currentLength

export const asideClasses = (maxLength, currentLength, warningFactor) => {
  const diff = remainingLength(maxLength, currentLength)
  return kuiperClassNames({
    aside: true,
    max: diff < 0,
    over: diff < 0,
    warning: diff < maxLength * warningFactor,
  })
}

export const buildThemes = (theme) => {
  if (!theme) return undefined
  return [...theme.split(' ')].map((themeName) => `theme-${themeName}`)
}

export const highlightText = (value, maxLength) => {
  const textUnder = value.substring(0, maxLength)
  const textOver = value.substring(maxLength) || ''
  return (
    <div className={kuiperClassNames('highlightable')}>
      {textUnder}
      <span className={kuiperClassNames('danger')}>{textOver}</span>
    </div>
  )
}
